// =====================================================
// 📁 components/QuotationViewItemsTable.tsx
// =====================================================

import React from 'react';

interface Props {
  items: any[];
  globalDiscountActive?: boolean;
}

const QuotationViewItemsTable: React.FC<Props> = ({
  items,
  globalDiscountActive = false,
}) => {
  return (
    <div
      className="
        rounded-sm border border-stroke
        bg-white shadow-default
        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      {/* Header */}
      <div
        className="
          border-b border-stroke
          px-5 py-4
          dark:border-strokedark
        "
      >
        <div
          className="
            flex items-center justify-between
          "
        >
          <div>
            <h3
              className="
                text-base font-semibold
                text-black dark:text-white
              "
            >
              Productos Cotizados
            </h3>

            <p
              className="
                mt-1 text-sm text-bodydark2
              "
            >
              {items?.length || 0} productos registrados
            </p>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead
            className="
              border-b border-stroke
              bg-whiter
              dark:border-strokedark
              dark:bg-meta-4
            "
          >
            <tr>
              <th
                className="
                  px-5 py-4 text-left
                  text-sm font-medium
                  text-black dark:text-white
                "
              >
                Producto
              </th>

              <th
                className="
                  px-5 py-4 text-left
                  text-sm font-medium
                  text-black dark:text-white
                "
              >
                SKU
              </th>

              <th
                className="
                  px-5 py-4 text-right
                  text-sm font-medium
                  text-black dark:text-white
                "
              >
                Cantidad
              </th>

              <th
                className="
                  px-5 py-4 text-right
                  text-sm font-medium
                  text-black dark:text-white
                "
              >
                Precio
              </th>

              <th
                className="
                  px-5 py-4 text-right
                  text-sm font-medium
                  text-black dark:text-white
                "
              >
                Desc.
              </th>

              <th
                className="
                  px-5 py-4 text-right
                  text-sm font-medium
                  text-black dark:text-white
                "
              >
                Total
              </th>
            </tr>
          </thead>

          <tbody>
            {items?.map((item) => (
              <tr
                key={item.id}
                className="
                  border-b border-stroke
                  transition hover:bg-primary
                  hover:bg-opacity-5
                  dark:border-strokedark
                "
              >
                {/* Producto */}
                <td className="px-5 py-4">
                  <p
                    className="
                      font-medium
                      text-black
                      dark:text-white
                    "
                  >
                    {item.productName}
                  </p>
                </td>

                {/* SKU */}
                <td className="px-5 py-4">
                  <span
                    className="
                      inline-flex rounded-sm
                      bg-whiter
                      px-2 py-1 text-xs
                      font-medium
                      text-black
                      dark:bg-meta-4
                      dark:text-white
                    "
                  >
                    {item.sku}
                  </span>
                </td>

                {/* Cantidad */}
                <td
                  className="
                    px-5 py-4 text-right
                    font-medium
                    text-black
                    dark:text-white
                  "
                >
                  {item.quantity}
                </td>

                {/* Precio */}
                <td
                  className="
                    px-5 py-4 text-right
                    text-black
                    dark:text-white
                  "
                >
                  ${item.unitPrice}
                </td>

                {/* Descuento */}
                <td className="px-5 py-4 text-right">
                  {Number(item.discountAmount || 0) > 0 ? (
                    <span
                      className="
                        inline-flex rounded-sm
                        bg-warning
                        bg-opacity-10
                        px-2 py-1 text-xs
                        font-medium
                        text-warning
                      "
                    >
                      {globalDiscountActive
                        ? `$${item.discountAmount}`
                        : `${item.discountPercent}% / $${item.discountAmount}`}
                    </span>
                  ) : (
                    <span className="text-xs text-bodydark2">-</span>
                  )}
                </td>

                {/* Total */}
                <td
                  className="
                    px-5 py-4 text-right
                    text-base font-semibold
                    text-primary
                  "
                >
                  ${item.total}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QuotationViewItemsTable;
